module.exports = __webpack_public_path__ + "6af0114619efa9fce8b52b6cf9bee2dc.png";